import { atom } from 'recoil';

const currentVanity = atom<string | number | null>({
  key: 'currentVanity',
  default: null,
});

export default currentVanity;
